import React from 'react';
import Modal from './Modal';

const ConfirmModal = ({
  show,
  onClose,
  onConfirm,
  title = 'Are you sure?',
  message = '',
  confirmText = 'Yes',
  cancelText = 'Cancel',
  confirmColor = 'btn-primary',
  cancelColor = 'btn-secondary',
  loading = false
}) => {
  return (
    <Modal
      show={show}
      onClose={onClose}
      title={title}
      footer={
        <>
          <button className={`btn ${cancelColor}`} onClick={onClose} disabled={loading}>
            {cancelText}
          </button>
          <button className={`btn ${confirmColor}`} onClick={onConfirm} disabled={loading}>
            {loading ? 'Processing...' : confirmText}
          </button>
        </>
      }
    >
      <div style={{ fontSize: '1.08rem', color: '#444', padding: '8px 0' }}>{message}</div>
    </Modal>
  );
};

export default ConfirmModal; 